import IMask from "imask";
import type { FactoryOpts } from "imask";

import { format, parse } from "@formkit/tempo";

export function getPhoneMask(): FactoryOpts {
  return { mask: "+00 00 000 00 00", lazy: false };
}

export function getEmailMask(): FactoryOpts {
  return { mask: /^\S*@?\S*$/ };
}

export function getPostalCodeMask(): FactoryOpts {
  return { mask: "0000" };
}

export function getLicensePlateMask(): FactoryOpts {
  return {
    mask: "aa N",
    lazy: false,
    prepare: (str: string) => str.toUpperCase(),
    blocks: {
      N: { mask: "0", repeat: [1, 6] },
    },
  };
}

const URL_PREFIX = "https://";
const URL_MAX_LENGTH = 250;

export function getUrlMask(): FactoryOpts {
  return {
    mask: URL_PREFIX + "*".repeat(URL_MAX_LENGTH - URL_PREFIX.length),
  };
}

export function getAmountMask(): FactoryOpts {
  return {
    mask: Number,
    scale: 2,
    radix: ".",
    mapToRadix: [","],
    thousandsSeparator: " ",
    padFractionalZeros: true,
    normalizeZeros: true,
  };
}

export function getDurationMask(): FactoryOpts {
  return {
    mask: "H\\hmm",
    lazy: false,
    blocks: {
      H: { mask: "0", repeat: [1, 3] },
      mm: { mask: IMask.MaskedRange, from: 0, to: 59 },
    },
  };
}

const DEFAULT_MIN_DATE = new Date(1970, 0, 1);
const DEFAULT_MAX_DATE = new Date(2030, 0, 1);

export function getDateMask(
  pattern = "YYYY/MM/DD",
  {
    min = DEFAULT_MIN_DATE,
    max = DEFAULT_MAX_DATE,
  }: { min?: Date; max?: Date } = {},
): FactoryOpts {
  return {
    mask: Date,
    pattern,
    lazy: false,
    min,
    max,
    format: (date: Date | null) => format(date ?? new Date(), pattern),
    parse: (str: string) => parse(str, pattern),
    blocks: {
      YYYY: {
        mask: IMask.MaskedRange,
        from: min.getFullYear(),
        to: max.getFullYear(),
      },
      MM: { mask: IMask.MaskedRange, from: 1, to: 12 },
      DD: { mask: IMask.MaskedRange, from: 1, to: 31 },
      HH: { mask: IMask.MaskedRange, from: 0, to: 23 },
      mm: { mask: IMask.MaskedRange, from: 0, to: 59 },
    },
  };
}
